var React = require('react');

function SearchInput (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.722 0c3.156 0 5.723 2.563 5.723 5.713 0 .976-.247 1.894-.68 2.699l3.789 3.783a1.52 1.52 0 0 1 0 2.152l-.209.208a1.528 1.528 0 0 1-2.155 0l-3.798-3.791a5.69 5.69 0 0 1-2.67.664C2.567 11.428 0 8.864 0 5.713 0 2.563 2.567 0 5.722 0Zm0 2.252a3.465 3.465 0 0 0-3.466 3.461 3.465 3.465 0 0 0 3.466 3.463A3.465 3.465 0 0 0 9.19 5.713c0-1.91-1.552-3.46-3.467-3.46Z","fill":"#FBFBFB","fillRule":"nonzero"}));
}

SearchInput.defaultProps = {"viewBox":"0 0 15 15"};

module.exports = SearchInput;

SearchInput.default = SearchInput;
